import React, { useState } from "react";
import { Modal, Card, Form, Button, Alert } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import axios from "axios";
import { forgotPasswordByMobileApi } from "../CustomerCRUD";

// Validation schema
const schema = Yup.object({
  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number"),
  newPassword: Yup.string()
    .required("New password is required")
    .min(6, "Password must be at least 6 characters long"),
});

const ForgetPassword = ({ show, onHide }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const handleForgotPassword = async (data) => {
    setLoading(true);
    setMessage("");
    try {
      const response = await forgotPasswordByMobileApi(
        data.mobile,
        data.newPassword
      );

      if (response.data.message === "Password updated successfully") {
        setMessage("Password reset successfully!");
        toast.success("Password reset successfully!");
        reset(); // Clear form
        setTimeout(() => onHide(), 2000); // Close modal after 2 seconds
      } else {
        setMessage(response.data.message);
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Forgot Password Error:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      setMessage(errorMessage);
      toast.error(errorMessage);
      setError("root", {
        type: "manual",
        message: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "#4c934c" }}>Forgot Password</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ minHeight: "300px" }}
      >
        {/* {message && (
          <Alert
            variant={message.includes("successfully") ? "success" : "danger"}
          >
            {message}
          </Alert>
        )} */}
        <Card style={{ width: "100%", maxWidth: "400px", padding: "20px" }}>
          <Form onSubmit={handleSubmit(handleForgotPassword)}>
            <Form.Group className="mb-3">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                type="text"
                {...register("mobile")}
                placeholder="Enter your 10-digit mobile number"
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                isInvalid={!!errors.mobile}
              />
              <Form.Control.Feedback type="invalid">
                {errors.mobile?.message}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                {...register("newPassword")}
                placeholder="Enter new password"
                isInvalid={!!errors.newPassword}
              />
              <Form.Control.Feedback type="invalid">
                {errors.newPassword?.message}
              </Form.Control.Feedback>
            </Form.Group>
            {errors.root && (
              <Alert variant="danger" className="mt-3">
                {errors.root.message}
              </Alert>
            )}
            <div className="text-center mt-3">
              <Button
                type="submit"
                disabled={loading || isSubmitting}
                style={{ backgroundColor: "#4c934c", borderColor: "#4c934c" }}
              >
                {loading || isSubmitting ? "Processing..." : "Reset Password"}
              </Button>
            </div>
          </Form>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default ForgetPassword;
